import { render, staticRenderFns } from "./ViewsTable.vue?vue&type=template&id=6bbb27d1&scoped=true"
import script from "./ViewsTable.vue?vue&type=script&lang=ts"
export * from "./ViewsTable.vue?vue&type=script&lang=ts"
import style0 from "./ViewsTable.vue?vue&type=style&index=0&id=6bbb27d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb27d1",
  null
  
)

export default component.exports